import { Controller } from "@hotwired/stimulus"

// UC-014-2: CSVダウンロードモーダル制御
export default class extends Controller {
  static targets = ["modal", "householdSelect", "sensorSelect", "householdSection", "sensorSection", "selectionModeRadio", "presetRadio", "customPeriod", "maxPeriodHint"]

  connect() {
    this.toggleSelectionMode()
    this.toggleCustomPeriod()
    this.updateMaxPeriod()
  }

  submitForm(event) {
    event.preventDefault()
    const form = event.target
    const url = form.action
    const formData = new FormData(form)
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html, text/csv"
      }
    }).then(response => {
      const contentType = response.headers.get("Content-Type") || ""
      if (contentType.includes("text/csv")) {
        const disposition = response.headers.get("Content-Disposition") || ""
        const filenameMatch = disposition.match(/filename="?([^"\s;]+)"?/)
        const filename = filenameMatch ? filenameMatch[1] : "download.csv"
        return response.blob().then(blob => {
          const a = document.createElement("a")
          a.href = URL.createObjectURL(blob)
          a.download = filename
          document.body.appendChild(a)
          a.click()
          const objectUrl = a.href
          a.remove()
          URL.revokeObjectURL(objectUrl)
          this.close()
        })
      } else if (contentType.includes("turbo-stream")) {
        return response.text().then(html => {
          document.getElementById("csv_modal_errors").innerHTML = ""
          Turbo.renderStreamMessage(html)
        })
      }
    })
  }

  open() {
    this.modalTarget.classList.remove("hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }

  toggleAllHouseholds(event) {
    this.householdSelectTarget.disabled = event.target.checked
    if (event.target.checked) {
      this.householdSelectTarget.value = ""
    }
  }

  toggleAllSensors(event) {
    this.sensorSelectTarget.disabled = event.target.checked
    if (event.target.checked) {
      this.sensorSelectTarget.value = ""
    }
  }

  toggleSelectionMode() {
    const selected = this.selectionModeRadioTargets.find(r => r.checked)
    if (!selected) return

    if (selected.value === "sensor") {
      this.householdSectionTarget.classList.add("hidden")
      this.sensorSectionTarget.classList.remove("hidden")
    } else {
      this.householdSectionTarget.classList.remove("hidden")
      this.sensorSectionTarget.classList.add("hidden")
    }
  }

  toggleCustomPeriod() {
    const customRadio = this.presetRadioTargets.find(r => r.value === "custom")
    if (customRadio && customRadio.checked) {
      this.customPeriodTarget.classList.remove("hidden")
    } else {
      this.customPeriodTarget.classList.add("hidden")
    }
  }

  updatePresetState() {
    // 集計単位に応じてプリセットの有効/無効を更新
    this.updateMaxPeriod()
  }

  updateMaxPeriod() {
    const aggregationSelect = this.element.querySelector("select[name='csv_export[aggregation_unit]']")
    if (!aggregationSelect) return

    const aggregationUnit = aggregationSelect.value

    // 集計単位別の最大期間（ミリ秒）
    const maxPeriods = {
      "1min_raw": 24 * 60 * 60 * 1000,       // 24時間
      "1min_calculated": 24 * 60 * 60 * 1000, // 24時間
      "1hour": 31 * 24 * 60 * 60 * 1000,      // 31日
      "1day": 365 * 24 * 60 * 60 * 1000       // 365日
    }

    const max = maxPeriods[aggregationUnit] || Infinity

    // プリセット期間（ミリ秒）
    const presetDurations = {
      "3hours": 3 * 60 * 60 * 1000,
      "12hours": 12 * 60 * 60 * 1000,
      "24hours": 24 * 60 * 60 * 1000,
      "1week": 7 * 24 * 60 * 60 * 1000
    }

    // 最大期間ヒントテキストを更新
    const maxPeriodLabels = {
      "1min_raw": "24時間",
      "1min_calculated": "24時間",
      "1hour": "31日",
      "1day": "365日"
    }
    if (this.hasMaxPeriodHintTarget) {
      const label = maxPeriodLabels[aggregationUnit] || ""
      this.maxPeriodHintTarget.textContent = `※ 最大設定可能期間: ${label}`
    }

    this.presetRadioTargets.forEach(radio => {
      const duration = presetDurations[radio.value]
      if (duration && duration > max) {
        radio.disabled = true
        if (radio.checked) {
          radio.checked = false
          this.toggleCustomPeriod()
        }
        const label = radio.nextElementSibling || radio.parentElement.querySelector("span")
        if (label) {
          label.classList.add("opacity-50", "cursor-not-allowed")
          label.classList.remove("cursor-pointer")
        }
      } else if (radio.value !== "custom") {
        radio.disabled = false
        const label = radio.nextElementSibling || radio.parentElement.querySelector("span")
        if (label) {
          label.classList.remove("opacity-50", "cursor-not-allowed")
          label.classList.add("cursor-pointer")
        }
      }
    })
  }
}
